class UserConfirmationRequest {
    constructor(title='', text='', confirm=((e)=>(console.log(e))), dismiss=((e)=>(console.log(e))), confirmObject=null) {
        this.title = title
        this.text = text
        this.confirm = confirm
        this.dismiss = dismiss
        this.confirmObject = confirmObject
    }
}

export default UserConfirmationRequest


// WEBPACK FOOTER //
// ./src/models/UserConfirmationRequest.js